export const posts = [
  {
    id: 'some-moments-not-meant-for-screens',
    title: 'Some Moments Are Not Meant for Screens',
    date: 'January 2025',
    category: 'UX Design',
    excerpt:
      'You do not want brightness. You do not want menus. You do not want options. You want one thing: Certainty. The best interface is the one your user barely has to enter.',
    image:
      'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    contentImage:
      'https://cdn.magicpatterns.com/uploads/aeFKf4bw6dvXbX72HbXy5v/linked-blogimage-1.jpg',
    linkedinUrl:
      'https://www.linkedin.com/posts/underlinedbydania_some-moments-are-not-meant-for-screens-activity-7421847368985104384-BmH1',
    content: `Some moments are not meant for screens.

Especially the moment right before sleep, when you're tired, reaching for something familiar.

A lot of products assume "more features = more value."
But at the bedside, control loses its charm.

You do not want brightness.
You do not want menus.
You do not want options that make you think.

You want one thing.
Certainty.

A physical button works because it asks nothing of you.
Tired. Quiet. Slightly impatient.
Your hand finds it without thinking.

This is why screenless interactions matter.
They lower the effort at the exact moment effort feels like too much.

It's the same reason a light switch still exists in the age of smart homes.
Some gestures are meant to stay simple, even in the dark.

Founders sometimes chase engagement by adding more layers.
But the products people keep are often the ones that disappear into habit.

The best interface is the one your user barely has to enter.`,
  },
  {
    id: 'most-forgettable-apps',
    title: 'Most Forgettable Apps Have One Thing in Common',
    date: 'January 2025',
    category: 'Strategy',
    excerpt:
      'They try to be everything to everyone. The apps that stick? They do one thing exceptionally well and make you feel something while doing it.',
    image:
      'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    linkedinUrl:
      'https://www.linkedin.com/posts/underlinedbydania_most-forgettable-apps-have-one-thing-in-common-activity-7419310465564168192-sIz6',
    content: `Most forgettable apps have one thing in common.

They try to be everything to everyone.

The apps that stick? They do one thing exceptionally well and make you feel something while doing it.

Think about the apps you actually use daily. They probably solve one specific problem brilliantly, rather than solving ten problems poorly.

Focus isn't a limitation. It's a superpower.

When you try to please everyone, you end up delighting no one. When you commit to serving a specific need deeply, you create something memorable.

The next time you're tempted to add another feature, ask yourself: does this make our core experience better, or just bigger?`,
  },
  {
    id: 'fastest-way-to-annoy-user',
    title: 'The Fastest Way to Annoy a User',
    date: 'January 2025',
    category: 'UX Design',
    excerpt:
      "Ask them for a review mid-task. Mid-focus. Mid-thought. Great apps wait. They ask after a win. Order completed. Level cleared. Goal achieved. That's when feedback feels natural, not forced.",
    image:
      'https://cdn.magicpatterns.com/uploads/mfcJdUfqRCDg2jFE3GbyFB/linked-blogimage-3.jpg',
    imagePosition: 'object-[center_45%]',
    contentImage:
      'https://cdn.magicpatterns.com/uploads/nsD5o44cY4AAr2Z75HVWcM/linked-blogimage-3.jpg',
    linkedinUrl:
      'https://www.linkedin.com/posts/underlinedbydania_the-fastest-way-to-annoy-a-user-is-to-ask-activity-7415686385304662016-gIBJ',
    content: `The fastest way to annoy a user is to ask them for a review when they least expect it.

Mid-task.
Mid-focus.
Mid-thought.

Remember every time you're in the middle of something important, and your food and the waiter interrupts to ask how everything is?

That interruption doesn't feel helpful.
It feels selfish because the person asking is prioritizing their own benefit.

When someone is in flow, they're in a state of deep concentration.
Breaking that moment pulls them out. It takes 23 minutes or more to recover.

That's why great apps wait.
They ask after a win.

Order completed.
Level cleared.
Goal achieved.

That's a happy moment.
That's when feedback feels natural, not forced.

Then there's the second problem.
The review prompt that pretends to be a question.

"Are you enjoying the app?"
Say yes, and you're sent straight to the App Store.`,
  },
]
